<template>
  <!-- 会员中心-互助会员 -->
  <div>
    <div class="mutualMember">
      <!-- 头部查询表单 -->
      <div class="headForm">
        <div class="head">互动会员</div>
        <div class="input-form-box" style="margin-top: 20px">
          <formOne :pageName="pageName" @onSerach="searchFormOne"></formOne>
        </div>
      </div>
      <div class="content">
        <!-- 表格 -->
        <el-table
          :data="tableData"
          v-loading="talbeLoading"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="memberNick" label="会员昵称" width="200"></el-table-column>
          <el-table-column prop="levelName" label="会员等级"></el-table-column>
          <el-table-column label="会员生日" prop="birthDay">
            <template slot-scope="scope">
              <span>{{scope.row.birthDay?scope.row.birthDay.split(" ")[0]:'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="point" label="当前积分" width="200"></el-table-column>
          <el-table-column prop="activationStatus" label="是否开卡" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.activationStatus | statusStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="activationTime" label="开卡时间"></el-table-column>
          <el-table-column prop="lastActivityTime" label="最后参与店铺活动时间"></el-table-column>
          <el-table-column label="操作" width="500">
            <template slot-scope="scope">
              <div class="btns">
                <span class="b1" @click="leverInfo(scope.row.id)" v-zoom="{ from: pageName, name: '会员信息' }">会员信息</span>
                <span class="b2" v-zoom="{ from: pageName, name: '积分日志' }" @click="pointsLog(scope.row.id)">积分日志</span>
                <span class="b2" v-zoom="{ from: pageName, name: '积分变更' }" @click="changePonitCahnge(scope.row.id)">积分变更</span>
                <span class="b2" v-zoom="{ from: pageName, name: '京豆日志' }" @click="handleJingDongLog(scope.row)">京豆日志</span>
                <span class="b2" v-zoom="{ from: pageName, name: '发京豆' }" @click="distributionBeans(scope.row)">发京豆</span>
                <span class="b2" v-zoom="{ from: pageName, name: '生日变更记录' }" @click="birthdayChangeRecord(scope.row)">生日变更记录</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="numTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 会员信息弹框 -->
    <el-dialog title="会员信息" :visible.sync="levelInfo" width="550px">
      <el-form :model="formData">
        <el-form-item label="会员昵称:" :label-width="formLabelWidth">
          <el-input v-model="formData.memberNick" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" :label-width="formLabelWidth">
          <el-input v-model="formData.mobile" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="会员等级:" :label-width="formLabelWidth">
          <el-input v-model="formData.levelName" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="当前积分:" :label-width="formLabelWidth">
          <el-input v-model="formData.point" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="是否开卡:" :label-width="formLabelWidth">
          <el-input v-model="formData.activationStatus" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="入会店铺:" :label-width="formLabelWidth">
          <el-input v-model="formData.shopTitle" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="开卡时间:" :label-width="formLabelWidth">
          <el-input v-model="formData.activationTime" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="最后参与活动时间:" :label-width="formLabelWidth">
          <el-input v-model="formData.lastActivityTime" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="会员生日:" :label-width="formLabelWidth">
          <div v-if="!isBirthDayEditing" style="display: flex; align-items: center; width: 250px">
            <span>{{ formData.birthDayStr ? formData.birthDayStr.split(" ")[0] : "-" }}</span>
            <el-button type="text" style="margin-left: 12px" @click="isBirthDayEditing = true; formData.birthDay = ''">编辑</el-button>
          </div>
          <el-date-picker
            v-else
            v-model="formData.birthDay"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 250px"
            class="birthDay-icon"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="levelInfo = false">取 消</el-button>
        <el-button type="primary" :disabled="!isBirthDayEditing || !formData.birthDay" @click="levelSure()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 积分日志弹框 -->
    <el-dialog :visible.sync="pointLog" width="980px">
      <div slot="title" class="dialog-title">
        <span>积分日志</span>
        <el-popover placement="right-start" width="200" trigger="hover" content="当前积分变更日志仅记录本积分系统所涉及的变更明细">
          <img class="img3" src="@/assets/images/u103.png" alt="" slot="reference" />
        </el-popover>
      </div>
      <el-table :data="gridData">
        <el-table-column property="changeTime" label="变更时间"></el-table-column>
        <el-table-column label="发放/扣除">
          <template slot-scope="scope">
            <span>{{ scope.row.changeScores > 0 ? "发放" : "扣除" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="变更积分值" property="changeScores"></el-table-column>
        <el-table-column property="currentScores">
          <template slot="header" slot-scope="scope">
            <span>当前积分值</span>
            <el-popover placement="right-start" width="200" trigger="hover" content="京东接口返回当前用户的积分值">
              <img class="img3" src="@/assets/images/u103.png" alt="" slot="reference" />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column property="reason" label="变更原因"></el-table-column>
        <el-table-column property="remark" label="变更备注"></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="logHandleSizeChange"
        @current-change="logHandleCurrentChange"
        :current-page="logCurrentPage"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalNum"
      ></el-pagination>
    </el-dialog>
    <!-- 积分变更弹框 -->
    <el-dialog title="积分变更" :visible.sync="changePonit" width="500px">
      <el-form :model="formDataOne">
        <el-form-item label="会员昵称：" :label-width="formLabelWidth">
          <el-input v-model="formDataOne.memberNick" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="当前积分：" :label-width="formLabelWidth">
          <el-input v-model="formDataOne.currentPoint" style="width: 250px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="变更操作：" :label-width="formLabelWidth">
          <el-radio-group v-model="formDataOne.sourceType">
            <el-radio label="27">发放</el-radio>
            <el-radio label="26">扣除</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="变更积分值：" :label-width="formLabelWidth">
          <el-input v-model="formDataOne.points" style="width: 250px" type="number" @change="linePan"></el-input>
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth">
          <el-input v-model="formDataOne.sourceComment" style="width: 250px" :maxlength="10"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changePonit = false">取 消</el-button>
        <el-button type="primary" @click="changePonitSure">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 京豆日志 -->
    <el-dialog :visible.sync="showJingDongLog" width="800px" @close="handleJingDongLogClose">
      <div slot="title" class="dialog-title">
        <span>京豆日志</span>
        <el-popover  placement="right-start" width="200" trigger="hover" content="当前京豆日志仅记录本系统内通过手动发放京豆的记录">
          <img class="img3" src="@/assets/images/u103.png" alt="" slot="reference" />
        </el-popover>
      </div>
      <el-table 
        max-height="500"
        :data="logDataList"
        v-loading="talbeLoading"
        style="width: '100%'; margintop: '20px'"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column 
          v-for="(item, index) in logHeaders" 
          :key="index"
          :prop="item.key" 
          :label="item.value" 
          :width="item.width? item.width : ''"
        ></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleLogSizeChange"
        @current-change="handleLogCurrentChange"
        :current-page="logCurrentPage2"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="logNumTotal"
        :small="true"
      ></el-pagination>
    </el-dialog>
    <!-- 发京豆 -->
    <el-dialog title="发京豆" v-if="showBeans" :visible.sync="showBeans" width="520px" @close="closeBeansDialog">
      <el-form :model="beansFrom" label-width="124px" class="beansFrom" ref="beansFrom" :rules="rules">
        <el-form-item label="会员昵称：" >
          <el-input v-model="beansFrom.memberNick" disabled></el-input>
        </el-form-item>
        <el-form-item label="选择京豆计划：" prop="plantId">
          <div class="select-pan">
            <el-select v-model="accountCode" style="width: 150px;margin-right: 8px;" placeholder="请选择" v-if="venderType">
              <el-option
                v-for="item in accountCodeList"
                :key="item.accountCode"
                :label="item.accountCode"
                :value="item.accountCode">
              </el-option>
            </el-select>
            <el-select v-model="beansFrom.planId" placeholder="请选择" @change="planIdChange" :class="venderType ? 'isSelect': 'noSelect'">
              <el-option
                v-for="item in plantOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <span class="refresh" @click="handleRefresh">刷新</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="createPlan">
              <el-button type="primary" @click="createPlan" style="padding: 5px !important">创建京豆计划</el-button>
          </div>
        </el-form-item>
        <el-form-item label="京豆计划余额：" >
          <el-input v-model="beansFrom.balance" disabled></el-input>
        </el-form-item>
        <el-form-item label="发放数量：" prop="sendAmount">
          <el-input v-model="beansFrom.sendAmount" placeholder="请输入发放数量"></el-input>
        </el-form-item>
        <el-form-item label="备注：" >
          <el-input v-model="beansFrom.remark" placeholder="请输入" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <jd-tips>
          <p>注：</p>
          <p>因官方接口限制，如选择的京豆计划单次发放类型上限为1000时，超过会多次发放，为确保发放成功，京豆计划发放次数必须大于等于单份奖励个数/1000；</p>
          <p>如需发放超过1000建议选择单次发放类型上限为50000的京豆计划，如超过50000，也会多次发放；</p>
        </jd-tips>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBeansDialog">取 消</el-button>
        <el-button type="primary" @click="distributionBeansSure">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="生日变更记录"
        :visible.sync="isShowBirthRecord"
        width="45%"
        @close="isShowBirthRecord = false"
      >
        <el-table
          :data="birthRecordData"
          v-loading="tableLoading"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
        <el-table-column 
          v-for="(item, index) in birthRecordHeaders" 
          :key="index"
          :prop="item.prop" 
          :label="item.label" 
          :width="item.width? item.width : ''"
        ></el-table-column>
        </el-table>
         <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleBirthSizeChange"
          @current-change="handleBirthCurrentChange"
          :current-page="birthRecordCurrent"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="birthRecordTotal"
          :small="true"
        ></el-pagination>
      </el-dialog>
  </div>
</template>

<script>
import topTitle from "../../../components/top-title";
// import inputForm from "../../../components/inputForm";
import { memberList, member, detail, point, details, getBeanRecordList, sendBean, beanList,getMemberBirthChangeRecord} from "@/api/integralCenter/memberController";
import {getSupplierAccountList} from "@/api/integralCenter/prizeCenter.js";
import formOne from "../inputFrom/input_form";
import jdTips from "@/components/common/jdTips.vue";
export default {
  name: "mutualMember",
  filters: {
    statusStr(status) {
      return { 0: "未开卡", 1: "已开卡", null: "null" }[status];
    },
  },
  components: {
    topTitle,
    // inputForm,
    formOne,
    jdTips
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    }
  },
  watch: {
    venderType:{
      handler(newVal) {
        if(newVal) {
          this.getSupplierList()
        }
      },
      immediate:true
    },
    venderId: {
      handler(newVal) {
        if(newVal&&this.venderType) {
          this.formAccount.accountCode = newVal
          this.formAccount.accountType = "1"
        } 
      },
      immediate: true
    },
    accountCode:{
      handler(newVal) {
        if(newVal) {
          if(newVal=="商家账户") {
            this.formAccount.accountCode = this.venderId
            this.formAccount.accountType = "1"
          }else {
            this.formAccount.accountCode = newVal
            this.formAccount.accountType = "2"
          }
        }
        this.beansFrom.planId = ""
        this.getBeanList()
      }
    }
  },
  data() {
    var checkPositiveInteger = (rule, value, callback) => {
      let reg = /^[1-9]\d*$/;
      if (!value) {
        return callback(new Error("发放数量不能为空"));
      }
      if (!reg.test(value)) {
        callback(new Error("请输入正整数"));
      } else if(Number(value) > Number(this.beansFrom.balance)){
        callback(new Error("发放数量不能大于京豆计划余额"));
      }else {
        callback();
      }
    };
    return {
      birthRecordCurrent: 1,

      birthRecordHeaders: [
        { label: "变更时间", prop: "createTime" },
        { label: "变更前生日时间", prop: "birthDayBefore" },
        { label: "变更后生日时间", prop: "birthDayAfter" },
        { label: "变更备注", prop: "changeRemark" },
      ],
      birthRecordData: [],
      birthRecordTotal: 0,
      tableLoading: false,
      birthRecordInfo: {
        current: 1,
        size: 10,
      },
      isShowBirthRecord: false,
      memberInfo: null,
      formAccount: {
        accountCode: "",
        accountType: ""
      },
      accountCode: "商家账户",
      accountCodeList:[],
      pageName: "忠诚度管理-互动会员",
      numTotal: 0,
      totalNum: 0,
      //会员信息弹框
      levelInfo: false,
      isBirthDayEditing: false,
      form: {
        resource: "1",
      },
      formLabelWidth: "150px",
      value1: "",
      //积分日志弹框
      pointLog: false,
      logCurrentPage: 1,
      gridData: [],
      //积分变更弹框
      changePonit: false,
      // 头部表单配置项
      inputData: [
        {
          name: "会员昵称:",
          val: "nick",
          placeholder: "请输入会员昵称",
        },
        {
          name: "客户pin:",
          val: "pin",
          placeholder: "请输入客户pin",
        },
        {
          name: "手机号码:",
          val: "mobile",
          placeholder: "请输入手机号码",
        },
        {
          name: "会员等级:",
          val: "memberLevel",
          selectArr: [
            { label: "一星会员", id: 1 },
            { label: "二星会员", id: 2 },
            { label: "三星会员", id: 3 },
            { label: "四星会员", id: 4 },
            { label: "五星会员", id: 5 },
          ],
        },
        {
          name: "是否开卡:",
          val: "memberLevel",
          selectArr: [
            { label: "已开卡", id: 1 },
            { label: "未开卡", id: 0 },
          ],
        },
        {
          name: "开卡时间:",
          myDate: true,
          val: ["cardStartTime", "cardEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "最后参与活动时间:",
          myDate: true,
          val: ["lastStartTime", "lastEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      talbeLoading: false, // 控制表格loading状态
      tableData: [], // 表格数据
      currentPage: 1, // 表格当前页
      levelData: {
        // activationEndTime: "", //开卡时间-结束
        // activationStartTime: "", //开卡时间-开始
        // activationStatus: 0, //开卡状态：0未开卡，1已开卡
        current: 1,
        // lastActivityEndTime: "", //最后参与活动时间-结束
        // lastActivityStartTime: "", //最后参与活动时间-开始
        // level: 0, //会员等级
        // memberNick: "", //会员昵称
        // mobile: "", //手机号码
        // pin: "", //会员pin
        size: 10,
      },
      formData: {}, //积分日志
      formDataOne: {
        memberNick: "", //名称
        score: "", //当前积分
        sourceType: "27", //发放/扣除
        points: "", //变更积分值
        sourceComment: "", //备注
        memberId: "",
      }, //积分变更
      activationStatus: "",
      log: {
        size: 10,
        current: 1,
      },
      ids: "",
      mytimestart: "",
      mytimeend: "",
      opentime: true,
      // 控制发京豆弹框
      showBeans: false,
      beansFrom: {
        memberId: "",
        memberNick: "",
        planId: "",
        balance: "-",
        // balance: "10",
        sendAmount: "",
        remark: "",
      },
      plantOptions: [],
      rules: {
        planId: [
          { required: true, message: '请选择京豆计划', trigger: 'change' }
        ],
        sendAmount: [
          { required: true, validator: checkPositiveInteger, trigger: "blur" },
        ]
      },
      logDataList: [],
      logHeaders:[
        {key: "sendTime", value: "变更时间"},
        {key: "sendAmount", value: "变更京豆值", width: '120'},
        {key: "reason", value: "变更原因"},
        {key: "remark", value: "变更备注"},
      ],
      showJingDongLog: false,
      logCurrentPage2: 1,
      logNumTotal: 0,
      logPaginationData: {
        current: 1,
        size: 10,
      },
      actmemberId: "",
    };
  },
  created() {
    // for (let i = 0; i < 10; i++) {
    //   this.tableData.push({
    //     nick: "阿狸",
    //     memberLevel: "一星会员",
    //     currentInt: 27,
    //     isOpenCard: i & 1 ? "是" : "否",
    //     openCardTime: i & 1 ? "2019-07-02 00:00:00" : "-",
    //     lastTime: "2019-07-30 00:00:00",
    //   });
    // }
  },
  mounted() {
    this.time();
    this.memberList();
    // var loginValue = sessionStorage.getItem("loginValue");
    // if (loginValue == 1) {
    //   this.memberList();
    // }
  },
  methods: {
    getBirthChangeRecordPage(){
      this.tableLoading = true
      getMemberBirthChangeRecord({
        venderId: this.venderId,
        customerPin: this.memberInfo.customerPin,
        current: this.birthRecordInfo.current,
        size: this.birthRecordInfo.size,
      }).then((res)=>{
        this.tableLoading = false
        if(res.records&&res.records.length>0){
          this.birthRecordData = res.records
          this.birthRecordTotal = +res.total
        }
      }).catch(()=>{
        this.tableLoading = false
      })
    },
    // 生日变更记录
    birthdayChangeRecord(row) {
      this.memberInfo = row;
      this.isShowBirthRecord = true;
      this.getBirthChangeRecordPage()
    },
    async getSupplierList() {
      try {
        const res = await getSupplierAccountList()
        if(res.code==1) {
          let list = res.data
          this.accountCodeList = list.map((item)=>{
            let obj = {}
            obj['accountCode'] = item
            return obj
          })
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }else {
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }
      } catch (error) {
        
      }
    },
    time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      this.mytimestart = this.getDateStr(-30) + " 00:00:00";
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    linePan(val) {
      let test = /^[0-9]*[1-9][0-9]*$/;
      if (this.formDataOne.sourceType == "27") {
        if (!test.exec(val)) {
          this.$message.error("请输入正确数字！");
          return;
        }
      }
    },
    //会员信息确认
    levelSure() {
      let birthdayInfo = {
        birthDay: this.formData.birthDay,
        id: this.ids,
      };
      member(birthdayInfo)
        .then((res) => {
          if (res.code == 1) {
            this.memberList();
            this.$message.success("修改成功");
          }
        })
        .catch(() => {});
      this.levelInfo = false;
    },
    //会员信息
    leverInfo(id) {
      this.ids = id;
      this.isBirthDayEditing = false;
      this.levelInfo = true;
      detail(id)
        .then((res) => {
          if (res.code == 1) {
            this.formData = res.data;
            if (this.formData.activationStatus == 0) {
              this.formData.activationStatus = "未开卡";
            } else {
              this.formData.activationStatus = "已开卡";
            }
          }
        })
        .catch(() => {});
    },
    //获取列表数据
    memberList() {
      this.talbeLoading = true;
      if (this.opentime == true) {
        this.levelData.activationStartTime = this.mytimestart;
        this.levelData.activationEndTime = this.mytimeend;
        // this.levelData.lastActivityStartTime = this.mytimestart;
        //  this.levelData.lastActivityEndTime = this.mytimeend;
        this.opentime = false;
      }
      console.log(this.levelData);
      memberList(this.levelData).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.talbeLoading = false;
          this.tableData = res.data.records;
          this.numTotal = Number(res.data.total);
        }
      });
    },
    //积分日志
    pointsLog(value) {
      this.pointLog = true;
      this.log.memberId = value;
      // this.log.memberId="1304063433587437569"
      details(this.log).then((res) => {
        this.gridData = res.data.records;
        this.totalNum = Number(res.data.total);
      });
    },
    // 积分日志分页
    logHandleSizeChange(val) {
      this.log.size = Number(val);
      this.pointsLog(this.log.memberId);
    },
    logHandleCurrentChange(val) {
      this.log.current = Number(val);
      this.pointsLog(this.log.memberId);
    },
    //积分变更
    changePonitCahnge(id) {
      this.changePonit = true;
      this.formDataOne.memberId = id;
      this.formDataOne.points = null;
      this.formDataOne.sourceComment = "";
      detail(id)
        .then((res) => {
          if (res.code == 1) {
            this.formDataOne.memberNick = res.data.memberNick;
            this.formDataOne.currentPoint = res.data.point;
          }
        })
        .catch(() => {});
    },
    //积分变更确定
    changePonitSure() {
      if (this.formDataOne.sourceType == 26) {
        this.formDataOne.points = "-" + this.formDataOne.points;
      }
      point(this.formDataOne).then((res) => {
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.memberList();
        } else {
          this.$message.error(res.message);
        }
      });
      this.changePonit = false;
    },
    //查询
    searchFormOne(val) {
      this.logCurrentPage = 1;
      this.levelData.memberNick = val.theme;
      this.levelData.mobile = val.monile;
      this.levelData.pin = val.fullName;
      this.levelData.level = val.orderRemark;
      this.levelData.activationStatus = val.orderstatus;
      this.levelData.activationStartTime = val.orderStartTimeStart;
      this.levelData.activationEndTime = val.orderStartTimeEnd;
      this.levelData.lastActivityStartTime = val.sendStartTimeStart;
      this.levelData.lastActivityEndTime = val.sendStartTimeEnd;
      this.levelData.birthDayStart = val.birthDayStart ? val.birthDayStart : "";
      this.levelData.birthDayEnd = val.birthDayEnd ? val.birthDayEnd : "";
      this.levelData.current = 1;
      this.levelData.size = 10;
      this.memberList();
    },
    /**
     * 分页变化事件
     */
    handleSizeChange(val) {
      this.levelData.size = val;
      this.memberList();
    },
    handleCurrentChange(val) {
      this.levelData.current = val;
      this.memberList();
    },

    // 京豆日志按钮监听
    handleJingDongLog(row){
      console.log("row", row);
      this.actmemberId = row.id;
      this.getLogData();
      this.showJingDongLog = true;
    },
    // 京豆日志窗口关闭
    handleJingDongLogClose(){
      // 清空数据
      this.logNumTotal = 0;
      this.logDataList = [];
      // 关闭窗口
      this.showJingDongLog = false;
    },
    // 发京豆
    distributionBeans(row){
      console.log("当前行数据", row);
      this.beansFrom.memberNick = row.memberNick;
      this.beansFrom.memberId = row.id;
      this.getBeanList();
      this.showBeans = true;
    },
    // 发京豆确认按钮
    distributionBeansSure(){
      this.$refs["beansFrom"].validate((valid) => {
        if (valid) {
          if(Number(this.beansFrom.sendAmount) > Number(this.beansFrom.balance)){
            this.$message.error("发放失败！当前京豆计划账户余额不足~");
          }else {
            let params = {
              memberId: this.beansFrom.memberId,
              sendAmount: this.beansFrom.sendAmount,
              remark: this.beansFrom.remark,
              planId: this.beansFrom.planId
            }
            sendBean(params).then((res) => {
              if(res.code == 1){
                this.$message.success("发放成功！")
                this.closeBeansDialog();
              }else {
                this.$message.error(res.message);
              }
            }).catch(() =>  {})
          }
          
        } else {
          return false;
        }
      });
    },
    // 重置表单，关闭弹窗
    closeBeansDialog(){
      this.beansFrom = {
        memberId: "",
        memberNick: "",
        plantId: "",
        balance: "-",
        sendAmount: "",
        remark: "",
      }
      this.plantOptions = [];
      this.showBeans = false;
    },
    // 刷新按钮
    handleRefresh(){
      this.beansFrom.planId = "";
      this.beansFrom.balance = "-";
      this.plantOptions = [];
      this.getBeanList();
    },
    // 创建京豆计划
    createPlan(){
      // 跳转到资源项管理京豆
      let {href} = this.$router.resolve("/integralCenter/prizeCenter/asset_management");
      window.open(href, '_blank') 
    },
    // 京豆表格分页监听
    handleLogSizeChange(val){
      this.logPaginationData.size = val;
      this.getLogData();
    },
    handleLogCurrentChange(val){
      this.logPaginationData.current = val;
      this.getLogData();
    },
    handleBirthSizeChange(val) {
      this.birthRecordInfo.size = val;
      this.getBirthChangeRecordPage();
    },
    handleBirthCurrentChange(val) {
      this.birthRecordInfo.current = val;
      this.getBirthChangeRecordPage();
    },
    // 获取京豆日志数据
    getLogData(){
      let params = {
        ...this.logPaginationData,
        memberId: this.actmemberId
      }
      console.log('京豆日志参数', params);
      getBeanRecordList(params).then(res => {
        console.log("京豆日志", res);
        if(res.code == 1){
          this.logNumTotal = Number(res.data.total);
          let rdata = res.data.records;
          if(rdata.length > 0){
            this.logDataList = rdata;
          }
        }else {
          this.$message.error(res.message);
        }
      })
    },
    // 获取京豆计划
    getBeanList(){
      let params = {
        size: 100,
        current: 1,
        status: 4,
        accountCode: this.venderType ? this.formAccount.accountCode : undefined 
      }
      beanList(params).then(res=> {
        if(res.code == 1){
          let rdata = res.data.records;
          let selectArr = rdata.map((item) => {
            return {
              label: item.planName,
              value: item.id,
              sendTimes: item.sendTimes,
              // 京豆计划余额
              balance: item.quantityBalance
            };
          });
          this.plantOptions = selectArr;
        }else {
          this.$message.error(res.message);
        }
       
      })
    },
    // 京豆计划改变
    planIdChange(planIdTemp){
      console.log("this.plantOptions", this.plantOptions);
      const obj = this.plantOptions.find(item => item.value == planIdTemp)
      console.log("obj", obj);
      if(obj){
        this.beansFrom.balance = obj.balance;
        console.log("this.beansFrom.balance", this.beansFrom.balance);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.img3 {
  height: 18px;
  // position: flex;
  margin: 0 0 -4px 0;
}
.mutualMember {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  background: #fff;
  min-height: 88vh;
  .headForm {
    box-sizing: border-box;
    margin-top: 20px;
    padding: 24px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      border-bottom: 1px solid #f0f0f0;
      padding: 0 0 20px 50px;
      font-size: 16px;
      font-weight: bold;
      color: #2e3458;
    }
  }
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    // margin: 20px 0 50px 0;
    .btns {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      span {
        padding: 10px 2px;
      }
      .b1 {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #7b61ff;
        }
      }
      .b2 {
        margin-left: 20px;
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #7b61ff;
        }
      }
    }
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
.refresh {
  cursor: pointer;
  margin-left: 16px;
    color: #7f85e9;
    &:hover {
      color: #7b61ff;
    }
}
.beansFrom {
  position: relative;
  // .createPlan {
  //   position: absolute;
  //   right: 0;
  //   top: 0;
  // }
  .select-pan {
    display: flex;
    align-items: center;
    .isSelect {
      width: 150px;
    }
    .noSelect {
      width: 310px;
    }
  }
}
.birthDay-icon{
  /deep/ .el-icon-date{
    &::before{
      display: none;
    }
  }
}
</style>
